import HeaderTag from './HeaderTag';

export default HeaderTag;
